export default __webpack_public_path__ + "static/media/Hotel-LA-New-Delhi.7121845c.jpg";